import EventEditor from './EventEditor'

export default EventEditor
